import { Grid, Typography } from '@mui/material';
import { Checkbox } from '../../../../../components/general/fields/checkbox';
import { SarlaftSendEmailProps } from './props';
import { useSarlaftSendEmail } from './hook';

export const SarlaftSendMail = (props: SarlaftSendEmailProps) => {
    const { formik } = useSarlaftSendEmail(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Aviso formulario a intermediario
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Checkbox
                    label="Enviar email"
                    name="sendEmail"
                    checked={formik.values.sendEmail}
                    onChange={(checked: boolean) =>
                        formik.setFieldValue('sendEmail', checked)
                    }
                    onBlur={formik.handleBlur}
                    errors={formik.errors.sendEmail}
                />
            </Grid>
        </Grid>
    );
};
